import React from 'react';

// Components
import { ConversationNotifications } from '../modules/conversation-notifications/conversation-notifications';

// Styles
import './chat-status-unavailable.scss';

export const ChatStatusUnavailable = () => {

  const workerId = localStorage.getItem('worker_id');
  const returnPathname = localStorage.getItem('return_pathname') ?? `/expert/${workerId}`;

  return (<ConversationNotifications
    title={'Availability Issue'}
    text={'The Consultant is not available at the moment. You may try to contact them later. The payment for the Text Chat will be refunded to you.'}
    navigateAction={returnPathname}  />);
}
